import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography';
import ButtonSecondaryDark from '@nexus/lib-react/dist/core/Button/ButtonSecondaryDark';
import SvgAdd from '@nexus/lib-react/dist/core/Icon/icons/default/Add';
import mq from '../../../../../../commons/styles/mediaQueries';
import styled from '../../../../../../theme/styled';

const AddButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 16px;
  margin-bottom: 16px;
  margin-left: 12px;
  ${mq.desktop} {
    margin-top: 24px;
    margin-left: 0px;
  }
`;

const StyledButtonSecondaryDark = styled(ButtonSecondaryDark)`
  max-width: fit-content;
`;

const StyledParagraph3 = styled(Paragraph4)`
  text-transform: none;
  font-weight: bold;
`;

const AddIcon = styled(SvgAdd)`
  padding-right: 8px;
`;

export default {
  AddButtonContainer,
  StyledButtonSecondaryDark,
  StyledParagraph3,
  AddIcon,
};
